import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../lib/auth";
import Logo from "../components/Logo";
import GlassCard from "../components/GlassCard";
import { Loader2, CheckCircle2 } from "lucide-react";

const SubscriptionSuccess = () => {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [status, setStatus] = useState("checking");
  const polled = useRef(0);
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) { nav("/"); return; }
    let cancelled = false;
    const poll = async () => {
      if (cancelled) return;
      polled.current += 1;
      try {
        const r = await api.get(`/billing/status/${sessionId}`);
        if (r.data.payment_status === "paid") {
          setStatus("paid");
          const u = await refresh();
          setTimeout(() => {
            if (u && !u.onboarding_completed) nav("/onboarding", { replace: true });
            else if (u && u.role === "client" && !u.linked_practitioner_id) nav("/link-practitioner", { replace: true });
            else nav("/dashboard", { replace: true });
          }, 1200);
          return;
        }
        if (r.data.status === "expired" || polled.current > 20) {
          setStatus("expired");
          return;
        }
      } catch { /* ignore */ }
      setTimeout(poll, 2000);
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId, nav, refresh]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 py-12 gap-8 well-page-enter">
      <Logo size="text-4xl" />
      <GlassCard className="w-full max-w-md text-center" data-testid="subscription-success-card">
        {status === "checking" && (
          <div className="flex flex-col items-center gap-4 py-4">
            <Loader2 className="animate-spin text-[#8BA38E]" size={36} />
            <p className="text-base text-[#4A5D52]">Confirming your subscription…</p>
          </div>
        )}
        {status === "paid" && (
          <div className="flex flex-col items-center gap-4 py-4">
            <CheckCircle2 className="text-[#6A7F6C]" size={48} />
            <p className="text-xl font-semibold text-[#2A3B32]">You&apos;re all set</p>
            <p className="text-sm text-[#4A5D52]">Redirecting…</p>
          </div>
        )}
        {status === "expired" && (
          <div className="flex flex-col items-center gap-4 py-4">
            <p className="text-base text-[#4A5D52]">We couldn&apos;t confirm your payment.</p>
            <button onClick={() => nav("/subscribe")} className="text-[#8BA38E] underline" data-testid="retry-subscribe">
              Try again
            </button>
          </div>
        )}
      </GlassCard>
    </div>
  );
};

export default SubscriptionSuccess;
